import R from "ramda";

const convertToObjWithStatus = (list, status) =>
  R.reduce(
    (acc, cur) => ({
      ...acc,
      [cur]: { status }
    }),
    {},
    list
  );

export default (state, action) => {
  let nextActiveGroups = {};
  let nextInactiveGroups = {};
  let nextHideGroups = {};
  let resetFields = {};
  let yesStack;

  const {
    payload: {
      activeGroups,
      inactiveGroups,
      hideGroups,
      addToYesStack,
      removeFromYesStack
    }
  } = action;

  if (R.type(activeGroups) === "Array" && R.length(activeGroups) > 0) {
    nextActiveGroups = convertToObjWithStatus(activeGroups, "active");
  }

  if (R.type(inactiveGroups) === "Array" && R.length(inactiveGroups) > 0) {
    nextInactiveGroups = convertToObjWithStatus(inactiveGroups, "inactive");

    const getFieldsFromInactiveGroups = R.reduce(
      (acc, groupName) => [...acc, ...state.groups[groupName].fieldsList],
      []
    );
    const convertToResetField = R.reduce(
      (acc, cur) => ({
        ...acc,
        [cur]: {
          value: "",
          error: ""
        }
      }),
      {}
    );
    resetFields = R.compose(convertToResetField, getFieldsFromInactiveGroups)(
      inactiveGroups
    );
  }

  if (R.type(hideGroups) === "Array" && R.length(hideGroups) > 0) {
    nextHideGroups = convertToObjWithStatus(hideGroups, "hide");
  }

  if (addToYesStack || removeFromYesStack) {
    // TODO: waiting for implementing
    console.log(yesStack);
  }

  return {
    ...state,

    // Update group status
    groups: R.mergeDeepRight(
      state.groups,
      R.mergeAll([nextActiveGroups, nextInactiveGroups, nextHideGroups])
    ),

    // Update fields' value/error
    fields: R.mergeDeepRight(state.fields, R.mergeAll([resetFields]))
  };
};
